import React, { Component } from 'react';
import {Redirect} from "react-router-dom";
import FlatButton from "material-ui/FlatButton";
import TextField from 'material-ui/TextField/TextField';

import * as urls from "./urls";
import {Card, CardActions} from "material-ui/Card";
import {NavigationArrowBack} from "material-ui/svg-icons";
import ViewTitle from "components/layout/ViewTitle";
import connect from "react-redux/es/connect/connect";
import {
  shopUnblockForceRequest as shopUnblockForceRequestAction
} from "actions/shop";

import {ShopUnblockResourceName} from "./resources";


const cardActionStyle = {
  zIndex: 2,
  float: 'right',
};
class ShopForceUnblockRequest extends Component {
  state = {
    reason: 'Super Admin enable shop',
  };

  goBack = () => {
    this.props.history.push(urls.shopUnblockFrontendPath);
  };

  onChangeReason = (reason) => {
    this.setState({
      reason: reason.trim(),
    });
  };

  handleUnblockShopRequest = () => {
    const {record} = this.props;
    const data = {
      shop_id: record.shop_id,
      reason: this.state.reason,
    };
    this.props.dispatch(shopUnblockForceRequestAction(data));
  };

  render() {
    console.log('render 1');
    const {record} = this.props;
    if (!record) {
      return (
        <Redirect to={urls.shopUnblockFrontendPath} />
      );
    }
    console.log('render 2');
    // ELSE
    return (
      <div className="list-page">
        <Card style={ {padding: '5px'} }>
          <CardActions style={cardActionStyle} >
            <FlatButton primary label={'Back'}
                        onClick={this.goBack}
                        icon={ <NavigationArrowBack />}
            />
          </CardActions>
          <ViewTitle title={`Enable Shop: ${record.shop_name} (Shop ID: ${record.shop_id})`} />

          <div style={{padding: '20px'}}>
            <TextField disabled={true} floatingLabelText={'Shop ID'} value={record.shop_id} />
            <br />
            <TextField
              floatingLabelText={'Reason'}
              value={this.state.reason}
              onChange={(event, newValue) => this.onChangeReason(newValue)}
            />
            <br />
            <FlatButton
              primary label='Save'
              style={{ margin: '5px 12px', position: 'relative' }}
              disabled={!this.state.reason}
              onClick={this.handleUnblockShopRequest}
            />
          </div>
        </Card>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    record: state.admin.recordSelected[ShopUnblockResourceName],
  };
}
export default connect( mapStateToProps )(ShopForceUnblockRequest);



// WEBPACK FOOTER //
// ./src/routes/shop/ShopForceUnblockRequest.js